'use client';

import { c as _c } from "react/compiler-runtime";
import { useFavourites } from '@/app/_hooks/use-favourites';
import { type Course } from '@/types/CoursesV2Response';
import { HeartIcon } from './HeartIcon';
interface FavouriteCellProps {
  course: Course;
  org: string;
}

/**
 * Self-contained favourite toggle for a grid cell. Subscribes to favourites state
 * internally so the enclosing `columnDefs` don't need `isFavourite`/`toggleFavourite`
 * in their deps — keeping the column definitions referentially stable across toggles
 * so ag-grid doesn't reset the active filter model.
 */
export const FavouriteCell = t0 => {
  const $ = _c(10);
  const {
    course,
    org
  } = t0;
  const {
    isFavourite,
    toggleFavourite
  } = useFavourites();
  let t1;
  if ($[0] !== course.EventId || $[1] !== isFavourite) {
    t1 = isFavourite(course.EventId);
    $[0] = course.EventId;
    $[1] = isFavourite;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== course || $[4] !== org || $[5] !== toggleFavourite) {
    t2 = () => toggleFavourite(course, org);
    $[3] = course;
    $[4] = org;
    $[5] = toggleFavourite;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="flex h-full items-center justify-center"><HeartIcon filled={t1} onClick={t2} /></div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};